import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import { resources as Classes } from "./Classes";
import { resources as Attestations } from "./Attestations";
import { resources as CyclicSchedules } from "./CyclicSchedules";
import { resources as PreparatorySchedules } from "./PreparatorySchedules";
import { resources as PreparatoryClasses } from "./PreparatoryClasses";
import { resources as EditCyclicDisciplinesSchedules } from "./CyclicSchedules/EditDisciplines";
import { resources as CreateWeeklySchedule } from "./CreateWeeklySchedule";
import { resources as PreviewWeeklySchedule } from "./PreviewWeeklySchedule";
import { resources as RescheduleOccurrences } from "./RescheduleOccurrences";
import { resources as StreamsWeeklyScheduleTable } from "./StreamsWeeklySchedule";
import { resources as IncompleteSemesters } from "./IncompleteSemesters";
import { resources as PendingDecisions } from "./PendingDecisions";
import { resources as Grades } from "./Grades";
import { resources as ForeignLanguagesSchedules } from "./ForeignLanguagesSchedules";
import { resources as SportSchedules } from "./SportSchedeles";
import { resources as MakeUps } from "./MakeUps";
import { resources as Universities } from "./Universities";
import { resources as CurriculumSelectionCampaigns } from "./CurriculumSelectionCampaigns";
import { resources as CurriculumSelectionCampaignApplicationDetails } from "./CurriculumSelectionCampaignApplications/Details";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <LocalLibraryIcon />,
  name: "Учебна дейност",
  title: "Учебна дейност",
  subMenu: [
    CreateWeeklySchedule,
    CyclicSchedules,
    EditCyclicDisciplinesSchedules,
    StreamsWeeklyScheduleTable,
    PreparatorySchedules,
    PreparatoryClasses,
    ForeignLanguagesSchedules,
    SportSchedules,
    PreviewWeeklySchedule,
    RescheduleOccurrences,
    Classes,
    Attestations,
    IncompleteSemesters,
    PendingDecisions,
    Grades,
    MakeUps,
    Universities,
    CurriculumSelectionCampaigns,
    CurriculumSelectionCampaignApplicationDetails,
  ],
};
